import { AxiosError } from "axios";

export interface ConcurrencyErrorResponse {
  message: string;
  errorCode: string;
}

export class ConcurrencyError extends Error {
  public errorCode: string;

  constructor(message: string, errorCode: string = "CONCURRENCY_CONFLICT") {
    super(message);
    this.name = "ConcurrencyError";
    this.errorCode = errorCode;
  }
}

export const isConcurrencyError = (error: unknown): error is AxiosError<ConcurrencyErrorResponse> => {
  if (error instanceof AxiosError) {
    return (
      error.response?.status === 409 &&
      error.response?.data?.errorCode === "CONCURRENCY_CONFLICT"
    );
  }
  return false;
};

export const handleConcurrencyError = (error: unknown): never => {
  if (isConcurrencyError(error)) {
    throw new ConcurrencyError(
      error.response?.data?.message || 
      "This Work Order has been updated by another user. Please close and reopen this Work Order to get the latest changes.",
      error.response?.data?.errorCode || "CONCURRENCY_CONFLICT"
    );
  }
  throw error;
};
